const completedQuizText = document.getElementById('completed-quiz-text');
const duringQuizText = document.getElementById('during-quiz-text');
const nofoundQuizText = document.getElementById('nofound-quiz-text'); // New variable for nofound-quiz-text
const answers = {}; // To store the answers
const questions = document.querySelectorAll('[data-question]');
let currentQuestionIndex = 0;

if (questions && questions.length > 0) {
    function filterProductsBasedOnQuiz() {
        let foundProducts = false;
        const products = document.querySelectorAll('.filteredProductsLoop li');
        if (products && products.length > 0) {
            products.forEach((product) => {
                const matchesQuiz = Object.keys(answers).every((key) => {
                    const quizAnswer = answers[key];
                    const dataKey = key.replace(/_/g, '-');
                    const productDataAttribute = product.getAttribute(`data-${dataKey}`);
                    if (productDataAttribute) {
                        const productData = productDataAttribute.split(', ');
                        return productData.includes(quizAnswer);
                    }
                    return false;
                });

                if (matchesQuiz) {
                    product.style.display = 'block';
                    foundProducts = true;
                } else {
                    product.style.display = 'none';
                }
            });

            // Show nofound-quiz-text if no products are found, otherwise show completed-quiz-text
            if (foundProducts) {
                completedQuizText.style.display = 'block';
                nofoundQuizText.style.display = 'none';
            } else {
                completedQuizText.style.display = 'none';
                nofoundQuizText.style.display = 'block';
            }
        }
    }

    function resetProductsFilter() {
        const products = document.querySelectorAll('.filteredProductsLoop li');
        if (products && products.length > 0) {
            products.forEach((product) => {
                product.style.display = 'block';
            });
        }
    }

    // Call this function whenever the quiz is completed
    function checkIfQuizCompleted() {
        let isCompleted = true;
        questions.forEach((question) => {
            const questionKey = question.getAttribute('data-question');
            if (!answers[questionKey]) {
                isCompleted = false;
            }
        });

        if (isCompleted) {
            filterProductsBasedOnQuiz(); // Filter products once the quiz is completed
            duringQuizText.style.display = 'none';
        } else {
            resetProductsFilter();
            completedQuizText.style.display = 'none';
            nofoundQuizText.style.display = 'none';
            duringQuizText.style.display = 'block';
        }
    }

    // Initially, hide the completed quiz text
    if (completedQuizText) {
        completedQuizText.style.display = 'none';
    }

    function showCurrentQuestion() {
        questions.forEach((question, index) => {
            question.style.display = index === currentQuestionIndex ? 'block' : 'none';
        });
        document.getElementById('quiz-index').textContent = currentQuestionIndex + 1;
    }

    function updateNavigation() {
        // Enable/Disable Previous button
        document.getElementById('quiz-prev-btn').disabled = currentQuestionIndex === 0;

        // Enable/Disable Next button based on whether the current question is answered and if it's not the last question
        const isAnswerSelected =
            answers[questions[currentQuestionIndex].getAttribute('data-question')];
        const isLastQuestion = currentQuestionIndex === questions.length - 1;
        document.getElementById('quiz-next-btn').disabled = !isAnswerSelected || isLastQuestion;
    }

    // Rest of your code remains the same...

    function updateButtonsForLastQuestion() {
        const lastQuestionButtons = questions[questions.length - 1].querySelectorAll('button');
        const answerToThirdQuestion = answers['movable_or_fixed'];

        lastQuestionButtons.forEach((button) => {
            // Reset display and selection
            button.style.display = 'none';
            button.classList.remove('Button--selected');

            if (
                answerToThirdQuestion === 'movable' &&
                ['electric', 'manual'].includes(button.getAttribute('data-answer'))
            ) {
                button.style.display = 'block';
            } else if (
                answerToThirdQuestion === 'fixed' &&
                ['polyvegan', 'glass'].includes(button.getAttribute('data-answer'))
            ) {
                button.style.display = 'block';
            } else if (answerToThirdQuestion === 'idk') {
                button.style.display = 'block';
            }
        });

        // Remove the answer for the fourth question if the third question's selection changes
        delete answers['canopy_type'];
    }

    // Event listeners for question buttons
    questions.forEach((question) => {
        question.addEventListener('click', function (event) {
            if (event.target.tagName === 'BUTTON') {
                const answer = event.target.getAttribute('data-answer');
                const questionKey = this.getAttribute('data-question');
                answers[questionKey] = answer;

                // Update selected button style
                this.querySelectorAll('button').forEach((btn) =>
                    btn.classList.remove('Button--selected'),
                );
                event.target.classList.add('Button--selected');

                if (questionKey === 'movable_or_fixed') {
                    updateButtonsForLastQuestion();
                }

                checkIfQuizCompleted(); // Check if the quiz is completed after each selection
                updateNavigation();
            }
        });
    });

    // Event listeners for navigation buttons
    document.getElementById('quiz-prev-btn').addEventListener('click', function () {
        if (currentQuestionIndex > 0) {
            currentQuestionIndex--;
            showCurrentQuestion();
            updateNavigation();
        }
    });

    document.getElementById('quiz-next-btn').addEventListener('click', function () {
        if (currentQuestionIndex < questions.length - 1) {
            currentQuestionIndex++;
            showCurrentQuestion();
            updateNavigation();
        }
    });

    showCurrentQuestion(); // Initialize the first question display
    updateNavigation(); // Initial update
}
